var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"container"},[_c('h1',{staticClass:"section-title",staticStyle:{"text-align":"center","margin":"30px 0"}},[_vm._v("Sklep")]),_c('shop-products-list')],1)}
var staticRenderFns = []

export { render, staticRenderFns }